// extracted by mini-css-extract-plugin
export default {"textAreaField":"TextArea_textAreaField__KJmkA","requiredAsterisk":"TextArea_requiredAsterisk__W88zf"};